var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"videoContainer",staticClass:"media-video",attrs:{"id":'videoContainer' + _vm.videoIdx}},[_c('video',{ref:"video",staticClass:"video-js",attrs:{"id":"player"}}),_c('div',{staticStyle:{"display":"none"}},[_vm._v(" "+_vm._s(_vm.source)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }